import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import PageWrapper from '@components/page-wrapper/PageWrapper.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'PageEmpty',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageWrapper, { title: "" }))
}
}

})